module.exports = __webpack_public_path__ + "static/img/p10-1.763fa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mthfr/p10-1.png
// module id = h/m8
// module chunks = 0